import * as React from 'react'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import {
  PerformanceFinalEmployeeScoresInsightsDocument,
  ReviewFinalEmployeeScoresManagedByFilterInput,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { EmptyState } from 'modules/performance_process/components/insights/Answers/common/EmptyState'
import { GaussBell } from 'modules/performance_process/components/insights/Overview/PerformanceScoreGaussbell'
import { colorsForEmployeeScoreScaleId } from 'modules/performance_process/lib/employeeScoreColor'

export const FinalEmployeeScoresInsights: React.FC<{
  reviewId: string
  managedByFilter: ReviewFinalEmployeeScoresManagedByFilterInput | undefined
}> = ({ reviewId, managedByFilter }) => {
  const { data, loading, error } = useQuery(PerformanceFinalEmployeeScoresInsightsDocument, {
    variables: {
      reviewId: reviewId,
      managedByFilter: managedByFilter,
    },
  })

  const aggregate = data?.performance?.reviewFinalEmployeeScoresConnection?.aggregate
  const reviewProcess = data?.performance?.reviewProcess

  const total = aggregate?.count || 0
  const averageScore = aggregate?.average?.score || 0
  const count = aggregate?.terms?.score?.count || []
  const values = aggregate?.terms?.score?.values.map((v) => Math.round(Number(v))) || []

  const employeeScoreScale = reviewProcess?.scoreScale
  const colors = employeeScoreScale ? colorsForEmployeeScoreScaleId(employeeScoreScale?.id) : []

  const scoreCount =
    employeeScoreScale?.scale.map(({ value }, i) => {
      const index = values.indexOf(value)
      return {
        id: String(value),
        score: value,
        color: colors[i] ?? 'grey400',
        count: index === -1 ? 0 : (count[index] ?? 0),
      }
    }) ?? []

  const noData = !scoreCount.length || !total || !averageScore

  return (
    <>
      {loading || error ? (
        <Box minHeight="s400" alignItems="center" justifyContent="center">
          <Spinner />
        </Box>
      ) : noData ? (
        <EmptyState title={i18n.t('performance_process.insights.answers.empty_state_analytics')} />
      ) : (
        <GaussBell
          title={i18n.t('performance_process.insights.charts.score_distribution')}
          data={{ count: scoreCount, total: total, average: averageScore }}
        />
      )}
    </>
  )
}
